import { Component, OnInit, Input, ViewChild, TemplateRef } from '@angular/core';
import { ProTaskRemainderService, CommonService } from '../../../services/index';
import { ToasterService } from 'angular2-toaster';
import { FormBuilder, FormGroup, FormControl, AbstractControl, Validators } from '@angular/forms';
import { DatePipe } from "@angular/common";
import * as _ from 'lodash';
import swal from 'sweetalert2';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';

@Component({
    selector: 'proTaskRemainder',
    templateUrl: './proTaskRemainder.component.html'
})
export class ProTaskRemainderComponent implements OnInit {
    columns = [];
    isLoadMask: Promise<any>;
    loadingIndicator: boolean = true;
    branchList = [];
    addedData: any;
    scrollTimeout: any;
    suppressPaging: boolean = false;
    page = {
        limit: 25,
        count: 0,
        offset: 0,
    };
    allBranches = [];
    minDate: Date;
    remainderData: any;

    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    @ViewChild('editDeleteTemplate') editDeleteTemplate: TemplateRef<any>;
    @ViewChild('filterPanel') filterPanel;
    form = {
        "task_type": "",
        "remain_date": new Date(),
        "commit_date": new Date(),
        "pro": "",
        "doctor_name": "",
        "branch": "",
        "remarks": "",
        "task_id": ""
    };
    filterData = {
        "doctor_name": "",
        "remain_date": null,
        "commit_date": null,
        "entry_date": null
    };
    mode = "add";
    currDate: string;
    filterRemainDate: string;
    filterCommitDate: string;
    filterEntryDate: string;
    bsModalRef: BsModalRef;
    cancel_reason: string;
    cancel_task_id: number;

    constructor(public datePipe: DatePipe, public ProTaskRemainderService: ProTaskRemainderService, private commonService: CommonService, public toasterService: ToasterService, private modalService: BsModalService) {

    }

    ngOnInit(): void {
        this.columns = [
            { name: 'SNo', prop: 'sno', width: 70, minWidth: 70, maxWidth: 70, cellClass: 'cell-center', sortable: false, cellTemplate: this.snoTemplate, isCustomTemplate: true },
            { name: 'Month', prop: 'month', width: 100, minWidth: 100, maxWidth: 100, toggle: true },
            { name: 'Entry Date', prop: 'added_on', width: 100, minWidth: 100, maxWidth: 100, toggle: true },
            { name: 'Task', prop: 'task_type', width: 100, minWidth: 100, maxWidth: 100 },
            { name: 'Pro', prop: 'pro', sortable: false, width: 100, minWidth: 100, maxWidth: 100 },
            { name: 'Branch', prop: 'branch', sortable: false, width: 100, minWidth: 100, maxWidth: 100 },
            { name: 'Doctor Name', prop: 'doctor_name', sortable: false, width: 130, minWidth: 130, maxWidth: 130 },
            { name: 'Remainder Date', prop: 'remain_date', width: 150, minWidth: 150, maxWidth: 150, toggle: true },
            { name: 'Commitment Date', prop: 'commit_date', width: 160, minWidth: 160, maxWidth: 160, toggle: true },
            { name: 'Status', prop: 'status', sortable: false, width: 100, minWidth: 100, maxWidth: 100 },
            { name: 'Remarks', prop: 'remarks', sortable: false, width: 100, minWidth: 100, maxWidth: 100 },
            { name: 'Options', prop: 'options', width: 130, minWidth: 130, maxWidth: 130, sortable: false, cellClass: 'cell-center', cellTemplate: this.editDeleteTemplate, isCustomTemplate: true },
            { name: 'Cancel Reason', prop: 'cancel_reason', sortable: false, width: 150, minWidth: 150, maxWidth: 150 }

        ];
        // this.form = ['task_type', 'pro', 'doctor_name', 'branch', 'remain_date', 'commit_date', 'remarks'];
        this.allBranches = ['Nagercoil', 'Anna Nagar', 'Tiruppur', 'Tirunelveli', 'Madurai', 'Coimbatore', 'Theni', 'Head Office'];
        this.pageCallback({ offset: 0 });
        this.minDate = new Date(new Date().getFullYear(),
            new Date().getMonth(),
            new Date().getDate());
    }

    pageCallback(pageInfo: { count?: number, pageSize?: number, limit?: number, offset?: number }) {
        if (!this.suppressPaging) {
            this.page.offset = pageInfo.offset;
            this.getRemainderList();
        }
    }
    onChangePageSize(limit) {
        this.page.limit = limit;
        this.getRemainderList();
    }
    clearField(): void {
        this.form = {
            "task_type": "",
            "pro": "",
            "remain_date": new Date(),
            "commit_date": new Date(),
            "doctor_name": "",
            "branch": "",
            "remarks": "",
            "task_id": ""
        };
        this.filterPanel.close();
        this.getRemainderList();
    }
    clearFilter(): void {
        this.filterData = {
            "doctor_name": "",
            "remain_date": "",
            "commit_date": "",
            "entry_date": ""
        };
        this.applyFilter();
    }
    applyFilter(): void {
        this.filterRemainDate = this.datePipe.transform(this.filterData['remain_date'], 'yyyy/MM/dd');
        this.filterCommitDate = this.datePipe.transform(this.filterData['commit_date'], 'yyyy/MM/dd');
        this.filterEntryDate = this.datePipe.transform(this.filterData['entry_date'], 'yyyy/MM/dd');
        this.filterPanel.close();
        this.getRemainderList();
    }
    onScroll() {
        this.suppressPaging = true;
        if (this.scrollTimeout) {
            //celarTimeout(this.scrollTimeout);
        }
        this.scrollTimeout = setTimeout(() => {
            this.suppressPaging = false;
        }, 100)
    }

    public OnSaveDetails() {
        let remain_date = this.datePipe.transform(this.form['remain_date'], 'yyyy/MM/dd');
        let commit_date = this.datePipe.transform(this.form['commit_date'], 'yyyy/MM/dd');
        let params = {
            task_id: this.form['task_id'] ? this.form['task_id'] : 0,
            task_type: this.form['task_type'],
            pro: this.form['pro'],
            branch: this.form['branch'],
            doctor_name: this.form['doctor_name'],
            remain_date: remain_date,
            commit_date: commit_date,
            remarks: this.form['remarks'],
            mode: this.mode,
        }
        let that = this;
        that.isLoadMask = that.ProTaskRemainderService
            .OnSaveDetails(params)
            .then(function (res: any) {
                that.loadingIndicator = false;
                if (res.data.success) {
                    that.clearField();
                    swal('SUCCESS', res.data.message, 'success');
                } else {
                    swal('ERROR', res.data.message, 'error');
                }
            });
    }
    public updateRemainderList(row: any) {
        this.filterPanel.open();
        this.mode = "edit";
        this.form.task_type = row.task_type;
        this.form.pro = row.pro;
        this.form.branch = row.branch;
        this.form.doctor_name = row.doctor_name;
        this.form.remain_date = new Date(row.rem_date);
        this.form.commit_date = new Date(row.com_date);
        this.form.remarks = row.remarks;
        this.form.task_id = row.task_id;

    }
    public updateStatus(row) {
        this.mode = "change";
        let params = {
            status: row.status,
            mode: this.mode,
            task_id: row.task_id,
        }
        let that = this;
        swal({
            title: 'Are you sure to Change Status?',
            text: 'You will not be able to Change this File Again!',
            showCancelButton: true,
            confirmButtonText: 'Yes!',
            cancelButtonText: 'No!'
        })
            .then(function () {
                that.isLoadMask = that.ProTaskRemainderService
                    .OnSaveDetails(params)
                    .then(function (res: any) {
                        that.loadingIndicator = false;
                        if (res.data.success) {
                            that.getRemainderList();
                            swal(
                                'Changed',
                                res.data.message,
                                'success'
                            );
                        } else {
                            swal(
                                'ERROR',
                                res.data.message,
                                'error'
                            );
                        }
                    });

            }, function (dismiss) {

            });
        this.getRemainderList();
    }
    public getRemainderList() {
        let params = {
            start: `${this.page.offset}`,
            limit: `${this.page.limit}`,
            searchDoctorName: this.filterData['doctor_name'],
            filterCommitDate: this.filterCommitDate,
            filterRemainDate: this.filterRemainDate,
            filterEntryDate: this.filterEntryDate,
        }
        let that = this;
        this.isLoadMask = this.ProTaskRemainderService
            .getRemainderList(params)
            .then(function (res: any) {
                that.loadingIndicator = false;
                that.page.count = res.totCnt;
                that.remainderData = res.data;
            });
    }
    getRowClass(row) {
        this.currDate = new Date().toLocaleDateString();
        if (row.status == 'Pending' && row.remain_date <= this.currDate) {
            return {
                'remainder-doctor': row.status == 'Pending'
            };
        }
    }

    onClickExcelBtn() {
        setTimeout(function () {
            that.filterPanel.close();
        }, 10);
        const columns = this.columns.filter(obj => !obj.isCustomTemplate);
        let that = this,
            data = {
                columns: JSON.stringify(columns),
                data: JSON.stringify(this.remainderData),
                title: "Pro Task Remainder"
            };
        this.isLoadMask = this.commonService
            .printing(data)
            .then(function (res: any) {
                if (res['_body']) {
                    var headers = res['headers']["_headers"],
                        ctype = headers.get('content-type')[0],
                        cdispos = headers.get('content-disposition')[0],//'attachment;filename="New_Title_Report_As_On_14_11_2017.xlsx"',
                        filename = cdispos.replace(/attachment;filename=|"/gi, ''),
                        blob = new Blob([res['_body']], {
                            type: ctype
                        }),
                        link = document.createElement('a');

                    link.href = window.URL.createObjectURL(blob);
                    link.download = filename;
                    link.click();
                } else {
                    var toast = {
                        type: 'error',
                        title: 'ERROR',
                        body: res.message
                    };
                    that.toasterService.pop(toast);
                }
            });
    }

    cancelRemainder(row: any, template: TemplateRef<any>) {
        // let that = this;
        // this.bsModalRef = this.modalService.show(AddEditBranchComponent, {
        //     keyboard: false,
        //     ignoreBackdropClick: true
        // });
        // this.bsModalRef.content.title = mode + ' Branch Details';

        this.bsModalRef = this.modalService.show(template);
        this.cancel_task_id = row.task_id;
        // this.bsModalRef.content.branchLoadEvent.subscribe(($e) => {
        //     that.getBranchList();
        //     this.store.dispatch(new commonActions.LoadAllBranch());
        // });

    }

    onCancelRemainder() {
        const that = this;
        that.isLoadMask = that.ProTaskRemainderService
            .onCancelRemainder({
                task_id: this.cancel_task_id,
                cancel_reason: this.cancel_reason
            })
            .then(function (res: any) {
                if (res.success) {
                    that.cancel_task_id = null;
                    that.cancel_reason = "";
                    that.bsModalRef.hide()
                    that.getRemainderList();
                    swal(
                        'Changed',
                        res.message,
                        'success'
                    );
                } else {
                    swal(
                        'ERROR',
                        res.message,
                        'error'
                    );
                }
            });
    }

}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/transaction/proTaskRemainder/proTaskRemainder.component.ts